import { Box, Button, TextField } from '@material-ui/core';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Popover from '@material-ui/core/Popover';
import { makeStyles } from '@material-ui/core/styles';
import Switch from '@material-ui/core/Switch';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import { Drawer } from '@mui/material';
import axios from 'axios';
import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import 'react-sliding-pane/dist/react-sliding-pane.css';
import CrmUsers from '../Everest/CrmUsers';

const useStyles = makeStyles((theme) => ({
    typography: {
        padding: theme.spacing(2),
    },
}));

let validateType = '';
const DealerLocations = forwardRef((props, ref) => {
    const childDealerSegment = useRef([] as any);
    const [currentLocationRow, SetCurrentLocationRow] = useState([] as any);
    const [isPaneOpen, SetIsPaneOpen] = React.useState(false);
    const [dealerLocationData, SetDealerLocationData] = useState([]);
    const [dealerName, SetDealerName] = useState([] as any);
    const [editDealerID, SetEditDealerID] = useState(0);
    const [dealerID, SetDealerID] = useState(0);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const classes = useStyles();
    const [password, SetPassword] = React.useState('' as string);
    const [isActiveDealer, SetIsActiveDealer] = useState(false);
    const [IsMessengerOnly, SetIsMessengerOnly] = useState(false);
    const [rowDealer, SetRowDealer] = useState([] as any);
    const [openUserDrawer, SetOpenUserDrawer] = useState(false);
    const [isSyncing, setIsSyncing] = useState(false);
    const [isTwilioImporting, SetisTwilioImporting] = useState(false);
    const [isOptOut, setIsOptOut] = useState(false);
    const [openTwilioImportImport, setOpenTwilioImportImport] = useState(false);
    const [anchorElTwilioHistory, setAnchorElTwilioHistory] = React.useState(null);
    const [twilioSid, setTwilioSid] = useState('');
    const [twilioToken, setTwilioToken] = useState('');
    const [twilioPhoneNumbers, setTwilioPhoneNumbers] = useState('');
    const [twilioImportStatus, SetTwilioImportStatus] = useState('');
    const id = open ? 'simple-popover' : undefined;

    function handleClickAdmin(even: any, name: any) {
        alert(name);
    };

    let iRowNumber = 0;
    useImperativeHandle(ref, () => ({
        ShowDealerLocation(id: any, dealerName: any, rowDealer: any) {
            console.log('rowDealer');
            console.log(rowDealer);
            SetRowDealer(rowDealer);
            SetDealerName(dealerName);
            SetIsActiveDealer(rowDealer.isActive);
            SetIsMessengerOnly(rowDealer.isMessengerOnly);
            axios.get('https://target-crm-func-dealer-service-prod-002.azurewebsites.net/api/dealers/cloudportal-dealersetting/' + id + '?code=DDP0vDIHxmHNJD/OAm5mqA4nK2NhbCnW2jr61rZ40XQaZXEP1R4icQ==&clientId=apim-target-crm-api-gateway-prod')
                .then(result => SetDealerLocationData(result.data))
                .catch(error => alert('Error:' + error));
            SetEditDealerID(0);
            SetIsPaneOpen(true);
        }
    }));



    useEffect(() => {
        let adminPassword = sessionStorage.getItem('adminPassword');
        if (adminPassword != null) {
            SetPassword(adminPassword);
        }
    }, []);

    function handleTextAreaKeyPress(e: any) {
        if (e.keyCode == 13 && !e.shiftKey) {
            e.preventDefault();
            return false;
        }
    }

    const handleCloseAdmin = () => {
        setAnchorEl(null);
    };

    function closeModal() {
        SetIsPaneOpen(false);
    }

    function UploadLogo() {
        let el = document.getElementById('inputFileUpload');
        if (el != null) {
            el.click();
        }
    }

    function inputFileUploadOnchange(e: any) {
        let xPath = 'divLoogoPath-' + currentLocationRow.dealerID;
        let el = document.getElementById(xPath);
        if (el != null) {
            el.innerText = e.target.files[0].name
        }
    }
    function SaveDealerInfo() {
        axios.post('https://azurefunctionkg.azurewebsites.net/api/UpdateDealerInfo/' + currentLocationRow.dealerID + '?code=dTRFJG9SNg7btPCQgqO4aSROrEAxkGhFaOlbXbhUtZL1vYaFzGmXew==', JSON.stringify(currentLocationRow))
            .then(res => {
                console.log(res);
                console.log(res.data);
                if (res.data.startsWith('Error')) { alert(res.data); }
            })
            .catch(error => alert('Error: ' + error));
        dealerLocationLogo = "";
    }


    let dealerLocationLogo = '';
    function SaveDealerLogo() {
        let el: any = document.getElementById('inputFileUpload');
        if (el != null && el.files.length > 0) {
            dealerLocationLogo = "https://stdealer001.blob.core.windows.net/aci-dealer-logos/" + el.files[0].name;
            currentLocationRow.dealerLogo = dealerLocationLogo;
            let xPath = 'divLoogoPath-' + currentLocationRow.dealerID;
            let el1: any = document.getElementById(xPath);
            el1.innerText = '';
            var formData = new FormData();
            formData.append("image", el.files[0]);
            axios.post('https://azurefunctionkg.azurewebsites.net/api/FunctionUploadImage?code=g/WTI4oiaJVCvNM7v94Ov78kZaVRxgNGSfavXq0nrsdAMeEV/FTa/w==', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
                .then(res => {
                    console.log(res);
                    console.log(res.data);
                })
        }
    }


    const handleDealerLocationClick = (event: any, dealerID: any, row: any) => {
        if (DealerLocationClick == 1 || dealerID == editDealerID) {
            DealerLocationClick = 0;
            return;
        }
        SetEditDealerID(0);
        SetCurrentLocationRow([]);
        SetCurrentLocationRow(row);
    };

    function ValidatePassword() {
        let el: any = document.getElementById('inputAdminPassword');
        if (el == null) { return }

        if (el.value != 'admin2') {
            alert('Invalid password. Please try again');
            return;
        }
        SetPassword(el.value);
        setAnchorEl(null);
        sessionStorage.setItem('adminPassword', el.value);
        if (validateType == '') SetEditDealerID(dealerID);
        // if (validateType == 'optout') OptOutDefault(null);
        if (validateType == 'syncdb') SyncDBWithEverest(null);
        if (validateType == 'TwilioSync') handleClickTwilioGistory(null);
        validateType = '';

    }

    let DealerLocationClick = 0;
    let _currentRow;
    let _dealerID = 0;
    function EditDealerLocation(e: any, currentRow: any, isEditRow: any) {
        //alert('EditDealerLocation');
        if (isEditRow == 1) {
            SetDealerID(currentRow.dealerID);
            if (password == null || password == '') {
                setAnchorEl(e.currentTarget);
                return;
            }
            SetCurrentLocationRow(currentRow);
            SetEditDealerID(currentRow.dealerID);
            //childDealerSegment.current.GetDealerSegments(currentRow.dealerID);
            DealerLocationClick = 1;
        }
        else {
            SaveDealerLogo();
            SaveDealerInfo();
            SetEditDealerID(0);
        }
    }


    const handleActiveDealer = () => {
        if (password == null || password == '') { return; }
        SetIsActiveDealer(isActiveDealer == true ? false : true);
        console.log("rowDealer");
        console.log(rowDealer);
        let url = 'https://azurefunctionkg.azurewebsites.net/api/SetDealerActive/' + rowDealer.dealerID + '/' + (isActiveDealer == true ? false : true) + '?code=9e7e0AOUnSE/s1UxPxyOCZHN0nrOh81eZAOdvEBvsCf9bj1efIldMQ==';
        fetch(url)
            .then(response => response.json())
            .catch(error => alert('Error: ' + error));
    };

    function onLocationEditChange(row: any, f: any) {
        switch (f.target.id.toLowerCase()) {
            case "inputphone":
                row.phoneNumber = f.target.value;
                break;
            case "inputgoogle":
                row.googleProfileLink = f.target.value;
                break;
            case "inputfacebook":
                row.facebookProfileLink = f.target.value;
                break;
            case "inputmessagecount":
                row.messageCount = f.target.value;
                break;
            case "inputdealerlocationnickname":
                row.dealerLocationNickName = f.target.value;
                break;
        }
    }

    function SyncDBWithEverest(e: any) {
        if (e != null) {
            if (password == null || password == '') {
                validateType = 'syncdb';
                setAnchorEl(e.currentTarget);
                //validateType='';
                return;
            }
        }

        if (window.confirm("Are you sure you want to sync DB now?.") == true) {
            let url = `https://azurefunctionkg.azurewebsites.net/api/RunQuery/syncdbwitheverest:${rowDealer.dmsDealerIdCrm}?code=tDXDBXsV6USWD2TZ5TZdLQp6hLCiZqSyadujClZNG/Ragr39/wQjAw==`;
            setIsSyncing(true);
            axios.get(url)
                .then(result => (
                    alert(result.data),
                    setIsSyncing(false)
                ))
                .catch(error => (
                    alert('Error:' + error),
                    setIsSyncing(false)
                ));
        }

    }

    function ShowUsers() {
        SetOpenUserDrawer(true);
    }

    function CloseUserDrawer() {
        SetOpenUserDrawer(false);
    }

    const handleMessegeOnlyTwilioGistory = (event: any) => {
        var checkStatus = IsMessengerOnly == true ? false : true;
        SetIsMessengerOnly(checkStatus);
       
        let url = 'https://opeidentitymanagement.azurewebsites.net/api/v1/UserRole/toggleDealerMessengerOnlyRole';
        try {
            axios.post(url, {
                "dealerId": rowDealer.dealerID,
                "everestDmsDealerId": rowDealer.dmsDealerId,
                "toggleMessengerOnlyRole": checkStatus,
                "dmsType": rowDealer.dmsTypeId
            }).then(function (response) {
                // alert('done');
                url = 'https://azurefunctionkg.azurewebsites.net/api/SetMessengerOnly/' + rowDealer.dealerID + '/' + checkStatus + '?code=9e7e0AOUnSE/s1UxPxyOCZHN0nrOh81eZAOdvEBvsCf9bj1efIldMQ==';
                //let url = 'http://localhost:7071/api/SetMessengerOnly/' + rowDealer.dealerID + '/' + (IsMessengerOnly == true ? false : true) + '?code=9e7e0AOUnSE/s1UxPxyOCZHN0nrOh81eZAOdvEBvsCf9bj1efIldMQ==';
                //let url = 'http://localhost:7071/api/SetMessengerOnly/' + rowDealer.dealerID + '/' + checkStatus + '?code=9e7e0AOUnSE/s1UxPxyOCZHN0nrOh81eZAOdvEBvsCf9bj1efIldMQ==';
                // alert(url);
                fetch(url)
                    .then(response => response.json())
                    .then(data => {
                        alert('Done');
                    })
                    .catch(error => alert('Error: ' + error));


            }).catch(function (error) {
                alert(error);
            });
        }
        catch (err) {
            alert(err);
        }

    }
    const handleClickTwilioGistory = (event: any) => {
        if (event != null) {
            setAnchorElTwilioHistory(event.currentTarget);
            if (password == null || password == '') {
                validateType = 'TwilioSync';
                setAnchorEl(event.currentTarget);
                return;
            }
        }

        setOpenTwilioImportImport(true);
    };


    const handleImportTwilioImportClick = (event: any) => {
        // if(twilioSid.length<30) {alert('Invalid Twilio SID');return;}
        // if(twilioToken.length<30) {alert('Invalid Twilio Token');return;}
        // if(twilioPhoneNumbers.length<10) {alert('Invalid import phone number');return;}
        let obj: any = new Object();
        // obj.dealerId = dealerId;
        obj.TwilioSid = twilioSid;
        obj.TwilioToken = twilioToken;
        obj.PhoneNumbers = twilioPhoneNumbers;
        obj.DealerId = rowDealer.dealerID;

        let jsonString = JSON.stringify(obj);
        // let url=`http://localhost:7071/api/ImportDealerTwilioData/${jsonString}`;
        let url = `https://azurefunctionkg.azurewebsites.net/api/ImportDealerTwilioData/${jsonString}?code=Rbt36VX6TYe3AIOigmqg8DV5792syiCYDGL6ndgxnNJZAzFujIyKIA==`;
        //alert(url);
        //return;
        SetisTwilioImporting(true);
        SetTwilioImportStatus('Importing Twilio history....');
        axios.get(url)
            .then(result => (
                //alert(result.data),
                SetTwilioImportStatus(result.data),
                SetisTwilioImporting(false)
                // setIsOptOut(false)
            ))
            .catch(error => (
                //alert('Error:' + error),
                SetTwilioImportStatus('Error:' + error),
                SetisTwilioImporting(false)
                // setIsOptOut(false)
            ));
    }

    return (
        <div>
            {/* <SlidingPane
                className='some-custom-class'
                overlayClassName='some-custom-overlay-class'
                isOpen={isPaneOpen}
                title={dealerName}
                subtitle=''
                onRequestClose={closeModal}> */}
            <Drawer
                PaperProps={{ style: { width: 'auto', minWidth: "10%", maxWidth: "90%" } }}
                anchor="right"
                open={isPaneOpen}
                onClose={closeModal}
                variant={'temporary'}
            >
                <div style={{ padding: "13px 5px", backgroundColor: "#F2F3F4", fontWeight: "bold", fontSize: "large" }}>
                    {"Dealer: " + dealerName}
                </div>
                <div style={{ position: "fixed", top: "3px", right: "10px" }}>
                    <table>
                        <tr>
                            <td style={{ paddingRight: "15px" }}>
                                <Button variant="contained" onClick={handleClickTwilioGistory}>Import Twilio History</Button>
                                <Popover
                                    id={id}
                                    open={openTwilioImportImport}
                                    anchorEl={anchorElTwilioHistory}
                                    onClose={e => setOpenTwilioImportImport(false)}
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'left',
                                    }}
                                >
                                    <Typography>
                                        <Box style={{ margin: "15px" }}>
                                            <Box>
                                                <TextField
                                                    required
                                                    id="outlined-required"
                                                    label="Twilio SID"
                                                    // defaultValue=""
                                                    onChange={(e: any) => { setTwilioSid(e.target.value) }}
                                                    value={twilioSid}
                                                    style={{ width: "350px" }}
                                                />
                                            </Box>
                                            <Box>
                                                <TextField
                                                    required
                                                    id="outlined-required"
                                                    label="Twilio Token"
                                                    // defaultValue=""
                                                    onChange={(e: any) => { setTwilioToken(e.target.value) }}
                                                    value={twilioToken}
                                                    style={{ width: "350px", marginTop: "10px" }}
                                                />
                                            </Box>
                                            <Box>
                                                <TextField
                                                    required
                                                    id="outlined-required"
                                                    label="Import Phone Number(s) [Comma Separated]"
                                                    // defaultValue=""
                                                    onChange={(e: any) => { setTwilioPhoneNumbers(e.target.value) }}
                                                    value={twilioPhoneNumbers}
                                                    placeholder='(817) 460-1234, 8174605678'
                                                    style={{ width: "500px", marginTop: "10px" }}
                                                />
                                            </Box>
                                            <Box>
                                                <Button disabled={isTwilioImporting} variant='contained' style={{ marginTop: "20px" }} onClick={handleImportTwilioImportClick} >Import Data Now</Button>
                                            </Box>
                                            <Box style={{ margin: "15px" }}>
                                                {twilioImportStatus}
                                            </Box>
                                        </Box>
                                    </Typography>
                                </Popover>
                            </td>

                            <td style={{ paddingRight: "15px" }}>
                                <Button disabled={isSyncing} variant="contained" onClick={e => SyncDBWithEverest(e)}>Sync Data with Everest</Button>
                            </td>
                            <td style={{ paddingRight: "50px" }}>
                                <Button variant="contained" onClick={ShowUsers} > Users: {rowDealer.users}</Button>
                            </td>
                            <td>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={IsMessengerOnly}
                                            onChange={handleMessegeOnlyTwilioGistory}
                                            name="checkeMessengerOnly"
                                            color="primary"
                                        />
                                    }
                                    label="Messenger-Only"
                                />
                            </td>

                            <td>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={isActiveDealer}
                                            onChange={handleActiveDealer}
                                            name="checkeActiveDealer"
                                            color="primary"
                                        />
                                    }
                                    label="Active"
                                />

                            </td>

                        </tr>
                    </table>
                </div>

                <div style={{ margin: "5px 10px" }}>
                    <Table aria-label="simple table" className={"myTable"}>
                        <TableHead>
                            <TableRow>
                                <TableCell align="left">Dealer</TableCell>
                                <TableCell align="left">Address</TableCell>
                                <TableCell align="left">Credits</TableCell>
                                <TableCell align="left">Google</TableCell>
                                <TableCell align="left">Facebook</TableCell>
                                <TableCell align="left">Logo</TableCell>
                                <TableCell align="left">Verified</TableCell>                                
                                <TableCell align="left"></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {dealerLocationData.map((row: any) => {
                                let name = row.name + ' (' + row.dealerID + ')';
                                if (row.dealerLocationNickName != null && row.dealerLocationNickName != '') {
                                    name += '  [' + row.dealerLocationNickName + ']';
                                }

                                let phone = row.phoneNumber != null && row.phoneNumber.length == 10 ? '(' + row.phoneNumber.substring(0, 3) + ') ' + row.phoneNumber.substring(3, 6) + '-' + row.phoneNumber.substring(6, 10) : row.phoneNumber;
                                let className1 = row.dealerID == editDealerID ? 'displayNone' : '';
                                let className2 = row.dealerID == editDealerID ? 'displayTextArea' : 'displayNone';
                                let classCredit1 = className1;
                                let classCredit2 = className2;
                                if (row.companyDealerId != row.dealerID) {
                                    classCredit2 = 'displayNone';
                                    classCredit1 = '';
                                }

                                let isEditRow = 1;
                                let editIcon = 'http://icons.iconarchive.com/icons/designcontest/vintage/24/Pencil-icon.png';
                                if (row.dealerID == editDealerID) {
                                    editIcon = 'http://icons.iconarchive.com/icons/oxygen-icons.org/oxygen/24/Actions-document-save-icon.png';
                                    isEditRow = 0;
                                }
                                let logoPathid = 'divLoogoPath-' + row.dealerID;
                                let xHtml = '<div>test</div>';                                
                                return (
                                    <TableRow key={row.dealerID}
                                        onClick={(event) => handleDealerLocationClick(event, row.dealerID, row)}
                                    >
                                        {/* <TableCell><span className={className1}>{name}</span><input type='text' className={className2} value={name}></input></TableCell>  */}
                                        {/* <TableCell><span className={className1}>{name}</span><textarea className={className2}>{name}</textarea></TableCell>  */}
                                        <TableCell><span className={className1}>{name}</span><textarea style={{ width: '100%' }} id='inputDealerLocationNickName' className={className2} onChange={(e) => onLocationEditChange(row, e)} onKeyDown={handleTextAreaKeyPress}>{row.dealerLocationNickName}</textarea></TableCell>
                                        <TableCell>{row.address}</TableCell>
                                        {/* <TableCell align="center">{row.messageCount}</TableCell> */}
                                        <TableCell align="center"><span className={classCredit1}>{row.messageCount}</span><textarea id='inputMessageCount' className={classCredit2} onChange={(e) => onLocationEditChange(row, e)} onKeyDown={handleTextAreaKeyPress}>{row.messageCount}</textarea></TableCell>

                                        {/* <TableCell><span className= {className1}>{phone}</span><textarea id='inputPhone' className={className2} onChange={(e) => onLocationEditChange(row, e)}>{row.phoneNumber}</textarea></TableCell> */}
                                        {/* <TableCell><span className= {'noWhiteSpace {className1}' }>{phone}</span><textarea id='inputPhone' className={className2} onChange={(e) => onLocationEditChange(row, e)}>{row.phoneNumber}</textarea></TableCell> */}
                                        {/* <TableCell><span className={className1 + ' noWhiteSpace'}>{phone}</span><textarea id='inputPhone' className={className2} onChange={(e) => onLocationEditChange(row, e)} onKeyDown={handleTextAreaKeyPress}>{row.phoneNumber}</textarea></TableCell> */}

                                        {/* <TableCell style={{minWidth: '100px'}}><span className={className1}>{phone}</span><input id='inputPhone' className={className2} onChange={(e) => onLocationEditChange(row, e)} defaultValue={row.phoneNumber}></input></TableCell> */}
                                        {/* <TableCell><span className={className1}>{row.googleProfileLink}</span><textarea id='inputGoogle' className={className2} onChange={(e) => onLocationEditChange(row, e)}>{row.googleProfileLink}</textarea></TableCell>  */}
                                        <TableCell><span className={className1}><a className='noTextDecoration' target='_blank' href={row.googleProfileLink}> {row.googleProfileLink}</a></span><textarea id='inputGoogle' className={className2} onChange={(e) => onLocationEditChange(row, e)} onKeyDown={handleTextAreaKeyPress}>{row.googleProfileLink}</textarea></TableCell>
                                        {/* <TableCell><span className={className1}>{row.facebookProfileLink}</span><textarea  id='inputFacebook' height='100' className={className2} onChange={(e) => onLocationEditChange(row, e)}>{row.facebookProfileLink}</textarea></TableCell>  */}
                                        <TableCell><span className={className1}><a className='noTextDecoration' target='_blank' href={row.facebookProfileLink}> {row.facebookProfileLink}</a></span><textarea id='inputFacebook' style={{ height: "100px" }} className={className2} onChange={(e) => onLocationEditChange(row, e)} onKeyDown={handleTextAreaKeyPress}>{row.facebookProfileLink}</textarea></TableCell>
                                        {/* <TableCell><img height="22" src={row.dealerLogo}/></TableCell> */}
                                        <TableCell><table cellPadding="0" cellSpacing="0" id="tablenoborder">
                                            <tr><td> <a className='noTextDecoration' target='_blank' href={row.dealerLogo}> <img height="22" src={row.dealerLogo} /></a></td><td><button className={className2} onClick={UploadLogo}>Add</button></td></tr>
                                            <tr><td colSpan={2}><div id={logoPathid} className="fontxSmall"></div></td></tr>
                                        </table></TableCell>
                                        {/* <TableCell><img src='http://icons.iconarchive.com/icons/designcontest/vintage/24/Pencil-icon.png'></img></TableCell> */}
                                        {/* <TableCell align="center"><a href='#' className='noTextDecoration' onClick={() => EditDealerLocation(this, row, isEditRow)}><img src={editIcon}></img></a></TableCell> */}
                                        {/* <TableCell align="center"><a href='#' className='noTextDecoration' onClick={handleClickAdmin}><img src={editIcon}></img></a></TableCell> */}
                                        <TableCell>
                                            <div style={{marginLeft:"15px"}}>
                                                {row.tollFreeSubmission > 0 && (
                                                    row.tollFreeVerified>0?<>&#x2713;</>:<>&#x292C;</>
                                                )}
                                            </div>
                                     </TableCell>
  
                                        <TableCell align="center"><a href='#' className='noTextDecoration' onClick={e => EditDealerLocation(e, row, isEditRow)}><img src={editIcon}></img></a></TableCell>


                                    </TableRow>


                                )
                                return (
                                    <TableRow key={-row.dealerID}>
                                        <TableCell>test1111</TableCell>
                                    </TableRow>

                                )
                                // <tr><td colspan="8">test</td></tr>
                            }
                            )
                            }
                        </TableBody>
                    </Table>
                    <input id='inputFileUpload' type="file" name="file" className='displayNone' onChange={inputFileUploadOnchange} />
                </div>
                <Popover
                    //id={id}
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handleCloseAdmin}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                >
                    <Typography className={classes.typography}>
                        Admin Password&nbsp;
                        <input autoFocus type='password' id='inputAdminPassword' onKeyPress={event => {
                            if (event.key === 'Enter') {
                                ValidatePassword()
                            }
                        }} ></input>&nbsp;<button onClick={ValidatePassword}>Continue</button>
                    </Typography>
                </Popover>
                {/* <Segment ref={childDealerSegment}></Segment> */}
                {/* <CrmUsers open={openUserDrawer} dmsDealerId={rowDealer.dmsDealerIdCrm} onClose={CloseUserDrawer} tag='target'></CrmUsers> */}
                {/* </SlidingPane> */}
                {/* <CrmUsers open={openUserDrawer} dmsDealerId={rowDealer.dmsDealerIdCrm} onClose={CloseUserDrawer} tag='datawarehouse'></CrmUsers> */}
                <CrmUsers open={openUserDrawer} dealerId={rowDealer.dealerID} dmsDealerId={rowDealer.dmsDealerIdCrm} onClose={CloseUserDrawer} tag='datawarehouse' dmsType={rowDealer.dmsTypeId}></CrmUsers>
            </Drawer>

        </div>);
});

export default DealerLocations